import Link from "next/link";

import { authorPath } from "@/lib/blog/paths";
import type { BlogPost } from "@/lib/ghost";
import { formatDate } from "@/lib/utils";

const FOUNDER_AUTHOR_SLUGS: Record<string, string> = { aleem: "/team" };

export const authorHref = (slug: string) => FOUNDER_AUTHOR_SLUGS[slug] ?? authorPath(slug);

const DAY_MS = 24 * 60 * 60 * 1000;

const wasUpdatedAfterPublish = (post: Pick<BlogPost, "published_at" | "updated_at">) => {
  const published = Date.parse(post.published_at);
  const updated = Date.parse(post.updated_at);
  if (Number.isNaN(published) || Number.isNaN(updated)) return false;
  return updated - published > DAY_MS;
};

export const PostMeta = ({ post }: { post: BlogPost }) => {
  const author = post.primary_author;
  const updated = wasUpdatedAfterPublish(post);

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-sm text-gray-500">
      {author && (
        <>
          <Link
            href={authorHref(author.slug)}
            className="font-medium text-gray-700 transition-colors hover:text-gray-900"
          >
            {author.name}
          </Link>
          <span aria-hidden="true">·</span>
        </>
      )}
      {post.published_at && (
        <time dateTime={post.published_at}>{formatDate(post.published_at)}</time>
      )}
      {updated && (
        <>
          <span aria-hidden="true">·</span>
          <span>
            Updated <time dateTime={post.updated_at}>{formatDate(post.updated_at)}</time>
          </span>
        </>
      )}
      {post.reading_time > 0 && (
        <>
          <span aria-hidden="true">·</span>
          <span>{post.reading_time} min read</span>
        </>
      )}
    </div>
  );
};
